<template>
  <div class="support-container h-full">
    <transition name="slide-fade" mode="out-in">
      <!-- Ticket List View -->
      <ticket-list
        v-if="!selectedTicketId"
        key="list"
        :website-id="websiteId"
        @select-ticket="selectTicket" />

      <!-- Ticket Detail View -->
      <ticket-detail
        v-else
        :key="selectedTicketId"
        :ticket-id="selectedTicketId"
        @back="clearSelection" />
    </transition>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { hideLoadingSpinner } from '~/javascript/utils/hide_loader.js'
import TicketList from './ticket_list.vue'
import TicketDetail from './ticket_detail.vue'

// Props
defineProps({
  websiteId: {
    type: String,
    required: true
  }
})

// State
const selectedTicketId = ref(null)

// Methods
const selectTicket = (ticket) => {
  selectedTicketId.value = ticket.id
}

const clearSelection = () => {
  selectedTicketId.value = null
}

// Lifecycle
onMounted(() => {
  hideLoadingSpinner()
})
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.15s ease-in;
}

.slide-fade-enter-from {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
</style>
